import React from "react";
import { WarningOctagon, X } from "@phosphor-icons/react";

/**
 * SpeedWarningModal
 * ------------------------------------------------
 * Full-viewport driver-side alert that fires at 110 km/h — 10 km/h
 * under the public auto-alert threshold. Aggressive red styling with
 * pulsing border to grab attention without covering the whole map.
 */
export default function SpeedWarningModal({ open, peakKmh, onDismiss }) {
  if (!open) return null;
  return (
    <div
      data-testid="speed-warning-modal"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-destructive/40 backdrop-blur-sm p-4"
      role="alertdialog"
      aria-live="assertive"
    >
      <div
        className="relative w-full max-w-md bg-background border-4 border-destructive shadow-[6px_6px_0_0_#111] p-6 animate-pulse-once"
      >
        <button
          onClick={onDismiss}
          data-testid="speed-warning-dismiss"
          className="absolute top-2 right-2 p-1.5 text-foreground/60 hover:text-foreground"
          aria-label="Dismiss"
        >
          <X size={18} weight="bold" />
        </button>

        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 shrink-0 bg-destructive text-destructive-foreground flex items-center justify-center border-2 border-foreground">
            <WarningOctagon size={26} weight="fill" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-destructive">
              Speed Warning
            </div>
            <div className="font-display text-2xl leading-none">
              SLOW DOWN.
            </div>
          </div>
        </div>

        <p className="text-sm leading-relaxed mb-4">
          You've hit{" "}
          <span
            data-testid="speed-warning-peak"
            className="font-mono font-bold text-destructive"
          >
            {Math.round(peakKmh)} km/h
          </span>
          . At <strong>120 km/h</strong> the system will automatically
          post a public "slow down" alert on the RideGY Community feed
          with your name and photo — and flag your ride for admin review.
        </p>

        <p className="text-xs text-foreground/70 mb-5 font-mono leading-relaxed">
          Guyana highway limit: 80 km/h. Riders trust you to get them
          home safely.
        </p>

        <button
          onClick={onDismiss}
          data-testid="speed-warning-ack"
          className="w-full bg-foreground text-background py-3 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-destructive"
        >
          I'll slow down
        </button>
      </div>
    </div>
  );
}
